/* eslint-disable jsx-a11y/no-static-element-interactions */
import { API, graphqlOperation } from 'aws-amplify';
import { searchLikieesInQuery, searchLikieesQuery } from 'graphql/likiees/queries';
import React, { useEffect, useRef, useState } from 'react';
import { useAlert } from 'react-alert';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';
import useScrollEnd from 'shared/hooks/useScrollEnd';
import { getError } from 'utils/appHelpers';
import { collectProductInfo } from 'utils/projectHelpers';

const PollImageLikiees = ({ project, onSelectProduct }) => {
  const alert = useAlert();
  const container = useRef();
  const loadState = useRef({ canLoad: false });
  const [fetching, setFetching] = useState(true);
  const [products, setProducts] = useState({ items: [] });

  const getProductsData = async nextToken => {
    try {
      setFetching(true);
      loadState.current.canLoad = false;
      const body = { limit: 20, nextToken, sort: { direction: 'desc', field: 'createTime' } };
      if (project?.id) body.projects = [project?.id];
      const query = body.projects ? searchLikieesInQuery : searchLikieesQuery;
      const { data } = await API.graphql(graphqlOperation(query, body));
      setProducts(products => {
        const key = data.searchLikiees || data.searchLikieesIn;
        const merged = { ...key, items: [...products.items, ...key.items] };
        loadState.current.canLoad = merged.items.length < merged.total;
        loadState.current.token = merged.nextToken;
        return merged;
      });
    } catch (err) {
      alert.error(getError(err));
    } finally {
      setFetching(false);
    }
  };

  useScrollEnd(container, loadState, token => {
    getProductsData(token);
  });

  useEffect(() => {
    getProductsData();
  }, []);

  return (
    <div className='poll-products max-h-300 overflow-auto' ref={container}>
      {!!products?.items?.length &&
        products.items.map((item, index) => {
          const { mainImage, name } = collectProductInfo(item);
          return (
            <div key={index} className='mb-10'>
              <div className='d-flex align-items-center cursor-pointer' onClick={() => onSelectProduct(item)}>
                <div className='min-w-60 mr-8'>
                  <img width='60' className='rounded-6' height='60' src={mainImage} alt={item.name} />
                </div>
                <p className='text-ellipsis mb-0 pr-20'>{name}</p>
              </div>
            </div>
          );
        })}
      {fetching && <SkeletonLoader type='product-grid' count={4} />}
    </div>
  );
};

export default PollImageLikiees;
